import { useState, useEffect } from "react";
import { generateBNDataLayerProvider } from "../helpers/generateBNDataLayerProvider";
export var useBNDataLayerProvider = function (bnApiUrl, bnIdentity) {
    var _a = useState(generateBNDataLayerProvider("", "")), bnDataLayer = _a[0], setBNDataLayer = _a[1];
    useEffect(function () {
        var _a, _b;
        setBNDataLayer(generateBNDataLayerProvider(bnApiUrl, (_b = (_a = bnIdentity.user) === null || _a === void 0 ? void 0 : _a.accessToken) !== null && _b !== void 0 ? _b : ""));
    }, [bnApiUrl, bnIdentity.user]);
    return { bnDataLayer: bnDataLayer };
};
//# sourceMappingURL=useBNDataLayerProvider.js.map